export default __webpack_public_path__ + "static/media/low-throughput-plate-solution.e9749b40.png";